import { core } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

export interface ToReschedulePayload {
  purchase: core.PastPurchase;
  ticketGroup: core.TicketGroup;
  newNumTickets: number;
  newTicketTypeId: number;
}

export interface State {
  rescheduleToTicketGroup?: core.TicketGroup;
  rescheduleDateTime?: string;
  toReschedule?: ToReschedulePayload;
  requestedTableId?: number[];
  newNumTickets?: number;
  newTicketTypeId?: number;
}

export const initialState: State = {
  rescheduleToTicketGroup: undefined,
  rescheduleDateTime: undefined,
  toReschedule: undefined,
  requestedTableId: undefined,
};

export default function reducer(state = initialState, action: BaseTockAction): State {
  const { type, payload } = action;

  switch (type) {
    case AppConstants.RESCHEDULE_SET_RESCHEDULED: {
      return {
        ...state,
        toReschedule: payload,
      };
    }
    case AppConstants.RESCHEDULE_CLEAR_RESCHEDULED: {
      return {
        ...state,
        toReschedule: undefined,
      };
    }
    case AppConstants.RESCHEDULE_SET_RESCHEDULE_TO: {
      return {
        ...state,
        rescheduleToTicketGroup: payload.rescheduleToTicketGroup,
        rescheduleDateTime: payload.rescheduleDateTime,
        requestedTableId: payload.requestedTableId,
        newNumTickets: payload.newNumTickets,
        newTicketTypeId: payload.newTicketTypeId,
      };
    }
    case AppConstants.RESCHEDULE_CLEAR_RESCHEDULE_TO: {
      return {
        ...state,
        rescheduleToTicketGroup: undefined,
        rescheduleDateTime: undefined,
        requestedTableId: undefined,
        newNumTickets: undefined,
        newTicketTypeId: undefined,
      };
    }
    default:
      return state;
  }
}
